// Admin menu items with their required roles
const ADMIN_MENU_ITEMS = [
    {
        label: 'Data Usage',
        icon: 'fad fa-database',
        type: 'url',
        key: 'dataUsage',
        data: { state: 'admin.dataUsage', url: '/admin/dataUsage' },
        roles: ['superAdmin']
    },
    {
        label: 'Equipment',
        icon: 'fad fa-microchip',
        key: 'equipment',
        children: [
            {
                label: 'Alerts, Event Schedule & Logs',
                icon: 'fad fa-bell',
                type: 'url',
                key: 'equipment_notifications',
                data: { state: 'admin.equipmentNotifications', url: '/admin/equipmentNotifications' },
                roles: ['admin', 'partner', 'superAdmin']
            },
            {
                label: 'Legacy',
                icon: 'fad fa-microchip',
                type: 'url',
                key: 'equipment_legacy',
                data: { state: 'admin.equipment', url: '/admin/equipment' },
                roles: ['partner', 'superAdmin']
            },
            {
                label: 'Management',
                icon: 'fad fa-table',
                type: 'url',
                key: 'equipment_management',
                data: { state: 'admin.equipmentManagement', url: '/admin/equipmentManagement' },
                roles: ['admin']
            }
        ],
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'Groups',
        icon: 'fad fa-user-friends',
        type: 'url',
        key: 'groups',
        data: { state: 'admin.groups', url: '/admin/groups' },
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'LPR Management',
        icon: 'fad fa-car-side',
        type: 'url',
        key: 'lprManagement',
        data: { state: 'admin.lprManagement', url: '/admin/lprManagement' },
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'Monitoring',
        icon: 'fad fa-desktop',
        key: 'monitoring',
        children: [
            {
                label: 'General',
                icon: 'fad fa-desktop',
                type: 'url',
                key: 'general',
                data: { state: 'admin.monitoring', url: '/admin/monitoring' },
                roles: ['superAdmin']
            },
            {
                label: 'Live',
                icon: 'fad fa-waveform',
                type: 'url',
                key: 'live',
                data: { state: 'admin.liveMonitoring', url: '/admin/liveMonitoring' },
                roles: ['superAdmin']
            },
            {
                label: 'Video',
                icon: 'fad fa-video',
                type: 'url',
                key: 'video',
                data: { state: 'admin.videoMonitoring', url: '/admin/videoMonitoring' },
                roles: ['superAdmin']
            }
        ],
        roles: ['superAdmin']
    },
    {
        label: 'Organizations',
        icon: 'fad fa-building',
        type: 'url',
        key: 'organizations',
        data: { state: 'admin.organizations', url: '/admin/organizations' },
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'RCU Management',
        icon: 'fad fa-server',
        type: 'url',
        key: 'rcuManagement',
        data: { state: 'admin.rcuManagement', url: '/admin/rcuManagement' },
        roles: ['partner', 'superAdmin'] // Only partner and superAdmin
    },
    {
        label: 'Resources',
        icon: 'fad fa-folder',
        type: 'url',
        key: 'resources',
        data: { state: 'admin.resources', url: '/admin/resources' },
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'Rules',
        icon: 'fad fa-clipboard-list',
        type: 'url',
        key: 'rules',
        data: { state: 'admin.rules', url: '/admin/rules' },
        roles: ['partner', 'superAdmin']
    },
    {
        label: 'Sites',
        icon: 'fad fa-map-marked',
        type: 'url',
        key: 'adminSites',
        data: { state: 'admin.sites', url: '/admin/sites' },
        roles: ['partner', 'superAdmin']
    },
    {
        label: 'Types',
        icon: 'fad fa-tags',
        type: 'url',
        key: 'types',
        data: { state: 'admin.types', url: '/admin/types' },
        roles: ['partner', 'superAdmin']
    },
    {
        label: 'User Access Lists',
        icon: 'fad fa-list',
        type: 'url',
        key: 'userAccessLists',
        data: { state: 'admin.userAccessLists', url: '/admin/userAccessLists' },
        roles: ['admin', 'partner', 'superAdmin']
    },
    {
        label: 'Users',
        icon: 'fad fa-users',
        type: 'url',
        key: 'users',
        data: { state: 'admin.users', url: '/admin/users' },
        roles: ['admin', 'partner', 'superAdmin']
    },
];
export function buildReportsChildrenNodes() {
    return [
        {
            label: 'Diary',
            icon: 'fad fa-book',
            type: 'url',
            key: 'diary',
            leaf: true,
            data: { state: 'reports', params: { type: 'diary' }, url: '/reports/diary' }
        },
        {
            label: 'Events',
            icon: 'fad fa-calendar-alt',
            type: 'url',
            key: 'events',
            leaf: true,
            data: { state: 'reports', params: { type: 'events' }, url: '/reports/events' }
        },
        {
            label: 'LPR',
            icon: 'fad fa-car',
            type: 'url',
            key: 'lpr',
            leaf: true,
            data: { state: 'reports', params: { type: 'lpr' }, url: '/reports/lpr' }
        },
        {
            label: 'Production - Flow Meter',
            icon: 'fad fa-tachometer-alt',
            type: 'url',
            key: 'production-flowMeter',
            leaf: true,
            data: { state: 'reports', params: { type: 'production-flowMeter' }, url: '/reports/production-flowMeter' }
        },
        {
            label: 'Production - Tanks',
            icon: 'fad fa-oil-can',
            type: 'url',
            key: 'production-tanks',
            leaf: true,
            data: { state: 'reports', params: { type: 'production-tanks' }, url: '/reports/production-tanks' }
        },
        {
            label: 'Water Disposal',
            icon: 'fad fa-tint',
            type: 'url',
            key: 'water-disposal',
            leaf: true,
            data: { state: 'reports', params: { type: 'water-disposal' }, url: '/reports/water-disposal' }
        },
    ];
}
// Helper function to check if a user role has access to an item
function hasAccess(userRole, itemRoles) {
    // SuperAdmin has access to everything
    if (userRole === 'superAdmin') {
        return true;
    }
    // Partner has access to partner and admin items
    if (userRole === 'partner') {
        return itemRoles.includes('partner') || itemRoles.includes('admin');
    }
    // Admin only has access to admin items
    if (userRole === 'admin') {
        return itemRoles.includes('admin');
    }
    return false;
}
export function buildAdminChildrenNodes(userRole) {
    // Filter items based on user role with proper hierarchy
    return ADMIN_MENU_ITEMS
        .filter((item) => {
        // For items with children, include if user has access to any child
        if (item.children) {
            return item.children.some(child => hasAccess(userRole, child.roles));
        }
        // For items without children, use the item's own roles
        return hasAccess(userRole, item.roles);
    })
        .map((item) => {
        if (item.children) {
            const children = item.children
                .filter(child => hasAccess(userRole, child.roles))
                .map(child => ({
                label: child.label,
                icon: child.icon,
                type: child.type,
                key: child.key,
                leaf: true,
                data: child.data
            }));
            return {
                label: item.label,
                icon: item.icon,
                key: item.key,
                leaf: children.length === 0,
                children: children.length > 0 ? children : undefined
            };
        }
        return {
            label: item.label,
            icon: item.icon,
            type: item.type,
            data: item.data,
            key: item.key,
            leaf: true
        };
    });
}
// Main menu structure definitions
export function buildMainMenuNodes() {
    return [
        {
            label: 'Sites',
            icon: 'fas fa-map-marker-alt',
            type: 'url',
            data: { state: 'app', url: '/' },
            key: 'sites',
            leaf: true
        },
        {
            label: 'Dashboards',
            icon: 'fas fa-tachometer-alt',
            key: 'dashboards',
            children: [] // Will be populated dynamically
        },
        {
            label: 'Reports',
            icon: 'fas fa-chart-bar',
            key: 'reports',
            children: buildReportsChildrenNodes()
        },
    ];
}
export function buildAdminMenuNode(userRole) {
    const children = buildAdminChildrenNodes(userRole);
    return {
        label: 'Admin',
        icon: 'fas fa-cog',
        leaf: children.length === 0,
        children: children.length > 0 ? children : undefined
    };
}
export function buildAddNewDashboardNode() {
    return {
        label: 'Add New',
        icon: 'fad fa-plus',
        type: 'url',
        key: 'new',
        leaf: true,
        data: { state: 'dashboard', params: { id: 'new' }, url: '/dashboard/new' }
    };
}
